import React, { useEffect, useState, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import GoogleMap from './GoogleMap';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import useCustomerServicePreferences from './useCustomerServicePreferences';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';
import usePostcodeToLat from './usePostcodeToLat';
import OpeningTimes from './OpeningTimes';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';
import useCustomerSettings from '../../CustomHooks/useCustomerSettings';
import useFetch from '../../CustomHooks/useFetch';

export default function DeliverAndCollect(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [selfOrdering, setSelfOrdering] = useState(true);
    const [collect, setCollect] = useState(false);
    const [deliver, setDeliver] = useState(false);
    const [averageTimeToCollect, setAverageTimeToCollect] = useState(20);
    const [averageTimeToCollectError, setAverageTimeToCollectError] = useState('');
    const [averageTimeToDeliver, setAverageTimeToDeliver] = useState(30);
    const [averageTimeToDeliverError, setAverageTimeToDeliverError] = useState('');
    const [postcode, setPostcode] = useState('');
    const [postcodeError, setPostcodeError] = useState('');
    const [deliveryRange, setDeliveryRange] = useState(0);
    const [deliveryRangeError, setDeliveryRangeError] = useState('');
    const setGAPath = useGoogleAnalytics();
    const [getCustomerServicePreferencesHookResponse,
        updateCustomerServicePreferences,
        putCustomerServicePreferencesHookResponse] = useCustomerServicePreferences();
    const [getLatAndLong, getLatLongResponse] = usePostcodeToLat();
    const [lat, setLat] = useState(0);
    const [long, setLong] = useState(0);
    const [workingHoursSpec, setWorkingHoursSpec] = useState([]);
    const [translateGui] = useGuiTranslations();
    const [payAtTable, setPayAtTable] = useState(false);
    const [payWithCard, setPayWithCard] = useState(false);
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const [putCustomerSettingsHookResponse, putCustomerSettingsHook] = useFetch();

    useEffect(
        () => {
            if (getCustomerSettingsHookResponse.orderPaymentOptions) {
                setPayAtTable(getCustomerSettingsHookResponse.orderPaymentOptions.payOnTheTableEnabled);
                setPayWithCard(getCustomerSettingsHookResponse.orderPaymentOptions.payOnlineEnabled);
            }
        }, [getCustomerSettingsHookResponse]
    )

    const MemoMap = useCallback(<GoogleMap options={{
        center: { lat: lat, lng: long },
        zoom: 13,
        range: deliveryRange
    }} />, [lat, deliveryRange])


    useEffect(
        () => {
            console.log(workingHoursSpec);
        }, [workingHoursSpec]
    )

    useEffect(
        () => {
            //GA
            //window.gtag('config', 'UA-160225157-2', { 'page_path': '/DeliverAndCollectSettings' });
            setGAPath('/DeliverAndCollectSettings');

            //Breadcrumb
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        //a: 'Deliver & Collect',
                        //b: 'Settings > Deliver & Collect'
                        a: 1,
                        b: 2,
                    },
                }
            )
        }, []
    )

    useEffect(
        () => {
            if (getCustomerServicePreferencesHookResponse.selfOrdering != null) {
                console.log(getCustomerServicePreferencesHookResponse);
                setAverageTimeToCollect(getCustomerServicePreferencesHookResponse.averageTimeToCollect);
                setAverageTimeToDeliver(getCustomerServicePreferencesHookResponse.averageTimeToDeliver);
                setCollect(getCustomerServicePreferencesHookResponse.collect);
                setDeliver(getCustomerServicePreferencesHookResponse.deliver);
                setPostcode(getCustomerServicePreferencesHookResponse.postCode);
                setDeliveryRange(getCustomerServicePreferencesHookResponse.range / 1609);//mile ceviriyorum
                setSelfOrdering(getCustomerServicePreferencesHookResponse.selfOrdering);
                setWorkingHoursSpec(getCustomerServicePreferencesHookResponse.workingHoursSpec);

                if (getCustomerServicePreferencesHookResponse.postCode != '' && getCustomerServicePreferencesHookResponse.postCode != null) {
                    postcodeOnBlur(getCustomerServicePreferencesHookResponse.postCode);//haritayi cizsin diye tetikliyorum
                }
            }
        }, [getCustomerServicePreferencesHookResponse]
    )

    const validate = () => {
        if (collect && averageTimeToCollect == "") {
            setAverageTimeToCollectError('Please enter a value');
            return false;
        }
        else {
            setAverageTimeToCollectError('');
        }

        /*
        if (deliver && averageTimeToDeliver == "") {
            setAverageTimeToDeliverError('Please enter a value');
            return false;
        }
        else {
            setAverageTimeToDeliverError('');
        }

        if (deliver && postcode == "") {
            console.log('postcode error setting')
            setPostcodeError('Please enter a value');
            return false;
        }
        else {
            setPostcodeError('');
        }

        if (deliver && deliveryRange == "") {
            setDeliveryRangeError('Please enter a value');
            return false;
        }
        else {
            setDeliveryRangeError('');
        }
        */

        return true;

    }

    const submit = () => {
        
        /*
        if (postcodeError != '') {
            return;
        }
        else {
            console.log('postcode error bos degil');
        }
        */

        if (!validate()) {
            return;
        }

        console.log('buraya kadar geldik');
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
        updateCustomerServicePreferences({
            "selfOrdering": selfOrdering,
            "collect": collect,
            "deliver": deliver,
            "averageTimeToCollect": averageTimeToCollect,
            //"averageTimeToDeliver": averageTimeToDeliver,
            //"postCode": deliver ? postcode.toUpperCase() : '',
            //"range": Math.round(parseFloat(deliveryRange) * 1609),
            "workingHours": workingHoursSpec,
        });

        putCustomerSettingsHook(
            {
                url: '/admin/customersettings',
                addTokenHeader: true,
                method: 'PUT',
                postData: {
                    payOnTheTableEnabled: payAtTable,
                    payOnlineEnabled: payWithCard,
                },
            }
        )

    }

    const postcodeOnBlur = (_postcode) => {
        //sayfa yuklenirken react postcode degerini yeterince hizli update edemeyebiliyor
        //o nedenle parametre olarak gonderiyorum ama sayfa yuklendikten sorna
        //kullanici degistirir ise state'deki degeri kullaniyorum

        console.log('postcodeblur:' + _postcode);

        _postcode = _postcode.toUpperCase();

        if (_postcode != '') {
            getLatAndLong(_postcode, 'UK');
        }
        else {
            console.log('postcode value su bos');
        }
    }

    useEffect(
        () => {
            console.log(getLatLongResponse);
            if (getLatLongResponse.success != null) {
                if (getLatLongResponse.success == true) {
                    setLong(getLatLongResponse.longitude);
                    setLat(getLatLongResponse.latitude);
                    setPostcodeError('');
                }
                else {
                    setPostcodeError('Please check postcode');
                }
            }

            if (getLatLongResponse == false && !Array.isArray(getLatLongResponse)) {
                //404 almis, postcode veritabaninda yok
                setPostcodeError('Please check postcode');
            }

        }, [getLatLongResponse]
    )



    return (
        <div className={classes.root}>

            <div>
                <Checkbox checked={selfOrdering} onChange={(e) => setSelfOrdering(e.target.checked)} />{capitalizeFirstLetter(translateGui(67))}

                {
                    selfOrdering ?
                        <div style={{ paddingLeft: '10px' }}>
                            <div>
                                <Checkbox checked={payWithCard} onChange={(e) => setPayWithCard(e.target.checked)} />{capitalizeFirstLetter(translateGui(107))}

                            </div>
                            <div>
                                <Checkbox checked={payAtTable} onChange={(e) => setPayAtTable(e.target.checked)} />{capitalizeFirstLetter(translateGui(108))}
                            </div>
                        </div>
                        : null
                }


            </div>
            <div style={{ marginTop: '10px' }}>
                <div>
                    <Checkbox checked={collect} onChange={(e) => setCollect(e.target.checked)} /> {capitalizeFirstLetter(translateGui(68))}
                </div>
                {
                    collect ?
                        <div>
                            <TextField helperText={averageTimeToCollectError} error={averageTimeToCollectError == '' ? false : true} className={classes.textbox} value={averageTimeToCollect} onChange={(e) => setAverageTimeToCollect(e.target.value)} id="filled-number" label={capitalizeFirstLetter(translateGui(69))} type="number" InputLabelProps={{ shrink: true, }} variant="filled" />
                        </div>
                        : null
                }
            </div>
            <div style={{ display: 'block' }}>
                <Checkbox checked={deliver} onChange={(e) => setDeliver(e.target.checked)} /> Deliver

                    {
                    deliver && 1==2?
                        <div style={{display:'block'}}>
                            <div>
                                <TextField helperText={averageTimeToDeliverError} error={averageTimeToDeliverError == '' ? false : true} className={classes.textbox} value={averageTimeToDeliver} onChange={(e) => setAverageTimeToDeliver(e.target.value)} id="filled-number" label="Average time to deliver(minutes)" type="number" InputLabelProps={{ shrink: true, }} variant="filled" />
                            </div>
                            <div>
                                <TextField onBlur={(e) => postcodeOnBlur(e.target.value)} helperText={postcodeError} error={postcodeError == '' ? false : true} className={classes.textbox} value={postcode} onChange={(e) => setPostcode(e.target.value)} id="filled-number" label="Postcode" InputLabelProps={{ shrink: true, }} variant="filled" />
                            </div>
                            <div>

                                <TextField helperText={deliveryRangeError} error={deliveryRangeError == '' ? false : true} className={classes.textbox} value={deliveryRange} onChange={(e) => e.target.value == '' ? setDeliveryRange(0) : setDeliveryRange(e.target.value)} id="filled-number" label="Delivery range (miles)" type="number" InputLabelProps={{ shrink: true, }} variant="filled" />
                            </div>

                            {
                                lat != 0 ?
                                    MemoMap :
                                    null
                            }
                        </div>
                        : null
                }

            </div>
            <div>

            </div>
            <OpeningTimes workingHoursSpec={workingHoursSpec} setWorkingHoursSpec={setWorkingHoursSpec}></OpeningTimes>
            <div className={classes.okAndCancelButtonWrapper}>

                <Button onClick={submit} className={classes.okButton} color="primary" variant="contained" component="button">
                    Save
                </Button>
            </div>

        </div>
    )
}

const useStyles = makeStyles({
    root: {
    },
    okAndCancelButtonWrapper: { "backgroundColor": "#f7f7f7", "display": "flex", "justifyContent": "flex-end", "width": "100%", "left": "0" },
    okButton: { "margin": "10px 10px" },
    textbox: {
        '& input': {
            backgroundColor: 'white',
            width: '250px',
        },
    }
});